import type { ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

interface IPdfSectionHeaderProps {
    subtitle: ReactNode;
    title: ReactNode;
}

export const PdfSectionHeader = ({ title, subtitle }: IPdfSectionHeaderProps) => (
    <Stack gap="4px">
        <Text
            fontVariant="h6"
            color={colorsPalettes.carbon[500]}
            data-automation="pdf-section-title"
        >
            {title}
        </Text>
        <Text
            fontVariant="caption"
            color={colorsPalettes.carbon[300]}
            data-automation="pdf-section-subtitle"
        >
            {subtitle}
        </Text>
    </Stack>
);
